import {ASSIGNMENT_STATUS, ASSIGNMENT_TYPE, ENTITY_TYPE} from "Services/assignment/constants";

export default function filterEligibleAssignments(assignments){
  return assignments.filter(assignment => {
    let isEligible = true;
    if(assignment.assignmentType === ASSIGNMENT_TYPE.PROGRESS_MONITORING){
      const studentCompletedBenchmark = assignments.find(({assignmentType, status, entityType}) =>
        assignmentType === ASSIGNMENT_TYPE.BENCHMARK && entityType === ENTITY_TYPE.STUDENT && status === ASSIGNMENT_STATUS.DONE);
      const pendingBenchmarkAssignment = assignments.find(({assignmentType, status}) =>
        assignmentType === ASSIGNMENT_TYPE.BENCHMARK && status === ASSIGNMENT_STATUS.ASSIGNED);
      isEligible = (studentCompletedBenchmark || !pendingBenchmarkAssignment);
    }

    return isEligible;
  });
}